import { AbstractControl, ValidationErrors } from '@angular/forms';

// enums
import { CATEGOR_VALUE_TYPE } from 'src/app/core/enums/category/cate-value-types';

abstract class AdsValidators {

    constructor() {}


    /**
     * 
     * @param type 
     * @returns 
     */
    public static maxDeposit(type: CATEGOR_VALUE_TYPE) {

        /**
         * 
         */
        return (control: AbstractControl): ValidationErrors | null => {

            // ES6 Destruction
            let { price, deposit } = control.getRawValue();

            if (price && deposit) {
                
                price = Number((price || '')?.toString()?.replace(/,/gi, ''))
                deposit = Number((deposit || '')?.toString()?.replace(/,/gi, ''))
    
                switch(type){
                    case CATEGOR_VALUE_TYPE.PL:
                    case CATEGOR_VALUE_TYPE.LN:
                        if (deposit >= price) control.get('deposit')?.setErrors({ minDeposit: 'قيمة العربون  تساوي او اكبر من سعر المتر' })
                        else control.get('deposit')?.setErrors(null)
                    break;
                    default:
                        if (deposit >= price) control.get('deposit')?.setErrors({ maxDeposit: 'قيمة العربون اكبر من سعر العقار' })
                        else control.get('deposit')?.setErrors(null)
                    break;
                }
    
            }
    
            return null
    
        }
    }
}

export default AdsValidators;